module.exports = __webpack_public_path__ + "static/fonts/Fact-CondensedExtraLight.3b17d67.eot";